import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Stagger, staggerItem } from "@/lib/reveal";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

export const Services = () => {
  const { t } = useLanguage();
  const go = () => document.querySelector("#booking")?.scrollIntoView({ behavior: "smooth" });

  const servicesList = t.services.items || [];

  return (
    <section id="services" data-testid="services" className="py-24 md:py-32 bg-card border-y border-border">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal className="overline font-bold tracking-[0.2em]">{t.services.overline}</Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-foreground max-w-2xl leading-[1.1]">
                {t.services.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="max-w-md">
            <p className="text-base sm:text-lg text-foreground/80 font-medium leading-relaxed">
              {t.services.desc}
            </p>
          </Reveal>
        </div>

        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-border">
          {servicesList.map((s) => {
            const Icon = Icons[s.icon] || Icons.Activity;
            return (
              <motion.div
                key={s.title}
                variants={staggerItem}
                data-testid={`service-card-${s.title}`}
                className="group relative border-r border-b border-border bg-card p-8 md:p-10 hover:bg-secondary transition-colors duration-300"
              >
                <div className="flex items-start justify-between">
                  <div className="h-12 w-12 grid place-items-center rounded-sm border-2 border-border text-accent group-hover:bg-accent group-hover:text-white group-hover:border-accent transition-all duration-300">
                    <Icon size={22} strokeWidth={2} />
                  </div>
                  <ArrowUpRight size={20} className="text-accent opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                </div>
                <h3 className="mt-8 text-xl font-bold tracking-tight text-foreground">{s.title}</h3>
                <p className="mt-3 text-base text-foreground/80 font-medium leading-relaxed">{s.desc}</p>
                <button
                  onClick={go}
                  data-testid={`service-more-${s.title}`}
                  className="mt-6 text-sm font-bold tracking-wide text-accent link-underline cursor-pointer"
                >
                  {t.services.more} →
                </button>
              </motion.div>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
};
